import { createSlice } from "@reduxjs/toolkit";

const getUserSetting = {
  status: "ok",
  msg: "",
  sub: "",
  name: "",
  data: {
    owner: "org-new-hope-cloud",
    name: "butter",
    createdTime: "2025-06-05T11:19:16+08:00",
    updatedTime: "2025-06-06T07:01:43Z",
    deletedTime: "",
    id: "5740bbd2-f6d2-43d0-9dc3-9fb15990fdac",
    externalId: "",
    type: "normal-user",
    password: "zxcv1234",
    passwordSalt: "",
    passwordType: "sha512-salt",
    displayName: "butter",
    firstName: "",
    lastName: "",
    avatar: "",
    avatarType: "",
    permanentAvatar: "",
    email: "butter@mail.com",
    emailVerified: false,
    phone: "35931608441",
    countryCode: "US",
    region: "",
    location: "",
    address: [],
    affiliation: "Example Inc.",
    title: "",
    idCardType: "",
    idCard: "",
    homepage: "",
    bio: "",
    tag: "staff",
    language: "",
    gender: "",
    birthday: "",
    education: "",
    score: 2000,
    karma: 0,
    ranking: 0,
    balance: 0,
    currency: "",
    isDefaultAvatar: false,
    isOnline: false,
    isAdmin: true,
    isForbidden: false,
    isDeleted: false,
    signupApplication: "app-new-hope-cloud",
    hash: "",
    preHash: "",
    accessKey: "",
    accessSecret: "",
    accessToken: "",
    createdIp: "",
    lastSigninTime: "1749193303",
    lastSigninIp: "",
    github: "",
    google: "",
    qq: "",
    wechat: "",
    facebook: "",
    dingtalk: "",
    weibo: "",
    gitee: "",
    linkedin: "",
    wecom: "",
    lark: "",
    gitlab: "",
    adfs: "",
    baidu: "",
    alipay: "",
    casdoor: "",
    infoflow: "",
    apple: "",
    azuread: "",
    azureadb2c: "",
    slack: "",
    steam: "",
    bilibili: "",
    okta: "",
    douyin: "",
    kwai: "",
    line: "",
    amazon: "",
    auth0: "",
    battlenet: "",
    bitbucket: "",
    box: "",
    cloudfoundry: "",
    dailymotion: "",
    deezer: "",
    digitalocean: "",
    discord: "",
    dropbox: "",
    eveonline: "",
    fitbit: "",
    gitea: "",
    heroku: "",
    influxcloud: "",
    instagram: "",
    intercom: "",
    kakao: "",
    lastfm: "",
    mailru: "",
    meetup: "",
    microsoftonline: "",
    naver: "",
    nextcloud: "",
    onedrive: "",
    oura: "",
    patreon: "",
    paypal: "",
    salesforce: "",
    shopify: "",
    soundcloud: "",
    spotify: "",
    strava: "",
    stripe: "",
    tiktok: "",
    tumblr: "",
    twitch: "",
    twitter: "",
    typetalk: "",
    uber: "",
    vk: "",
    wepay: "",
    xero: "",
    yahoo: "",
    yammer: "",
    yandex: "",
    zoom: "",
    metamask: "",
    web3onboard: "",
    custom: "",
    webauthnCredentials: null,
    preferredMfaType: "",
    recoveryCodes: null,
    totpSecret: "",
    mfaPhoneEnabled: false,
    mfaEmailEnabled: false,
    multiFactorAuths: [
      {
        enabled: false,
        isPreferred: false,
        mfaType: "sms",
      },
      {
        enabled: false,
        isPreferred: false,
        mfaType: "email",
      },
      {
        enabled: false,
        isPreferred: false,
        mfaType: "app",
      },
    ],
    invitation: "",
    invitationCode: "",
    faceIds: null,
    ldap: "",
    properties: {},
    roles: [],
    permissions: [],
    groups: [],
    lastChangePasswordTime: "",
    lastSigninWrongTime: "",
    signinWrongTimes: 0,
    managedAccounts: null,
    mfaAccounts: null,
    needUpdatePassword: false,
    ipWhitelist: "",
  },
  data2: null,
};

const checkUserPassword = {
  status: "ok",
  msg: "",
  sub: "",
  name: "",
  data: null,
  data2: null,
};

const initialState = {
  getUserSetting,
  checkUserPassword,
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {},
});

// export const { setBlocks } = profile.actions;

export default profileSlice.reducer;
